<template>
  <div>
    <b-card :title="$t('settings.city.details')">
      <b-row v-if="city">
        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              {{ $t('settings.city.name_ar') }}:
            </dt>
            <dd class="col-sm-8">
              {{ city.name_ar }}
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.city.name_en') }}:
            </dt>
            <dd class="col-sm-8">
              {{ city.name_en }}
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.city.governorate_id') }}:
            </dt>
            <dd class="col-sm-8">
              {{ city.governorate ? city.governorate.name_ar : '-' }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              {{ $t('common.status') }}:
            </dt>
            <dd class="col-sm-8">
              <b-badge :variant="city.is_active ? 'success' : 'danger'">
                {{ city.is_active ? $t('common.active') : $t('common.inactive') }}
              </b-badge>
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.city.districts_count') }}:
            </dt>
            <dd class="col-sm-8">
              {{ city.districts_count || 0 }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          class="mt-2"
        >
          <b-button
            variant="primary"
            :to="{ name: 'settings-cities-edit', params: { id: $route.params.id } }"
          >
            {{ $t('common.edit') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            class="ml-1"
            @click="$router.go(-1)"
          >
            {{ $t('common.back') }}
          </b-button>
        </b-col>
      </b-row>

      <div
        v-else
        class="text-center py-4"
      >
        <b-spinner variant="primary" />
        <p class="mt-2">
          {{ $t('common.loading') }}
        </p>
      </div>

      <!-- Activity Logs Section -->
      <b-row
        v-if="hasPermission('view activity_logs') && city"
        class="mt-3"
      >
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'city'"
              :model-id="Number($route.params.id)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BSpinner,
    ActivityLogs,
  },
  computed: {
    ...mapGetters({
      city: 'cities/city',
    }),
  },
  mounted() {
    this.fetchCity()
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
    fetchCity() {
      this.$store.dispatch('cities/get', this.$route.params.id)
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
          this.$router.push({ name: 'settings-cities' })
        })
    },
  },
}
</script>
